import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  CalendarDays,
  GraduationCap,
  Users,
  TrendingUp,
  AlertTriangle,
  FileDown,
  Loader2,
} from "lucide-react";
import { generateAttendanceReportPDF } from "@/utils/attendanceReportPdfGenerator";
import { toast } from "@/hooks/use-toast";

interface ReportsFiltersProps {
  studentsWithLateAlertsCount: number;
  overallLateRate: number;
  filteredStudents?: any[];
  overallStats?: any;
  selectedGrade?: string;
  selectedSection?: string;
  selectedStage?: string;
  periodDateRange?: { startDate: Date; endDate: Date };
  weeklyData?: any[];
  hasMultipleStages?: boolean;
  attendanceStats?: any;
}

export const ReportsFilters = ({
  filteredStudents = [],
  overallStats = {},
  selectedGrade,
  selectedSection,
  selectedStage,
  periodDateRange,
  weeklyData = [],
  hasMultipleStages = false,
  attendanceStats,
}: ReportsFiltersProps) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadPDF = async () => {
    if (isDownloading) {
      return;
    }

    try {
      // التحقق من وجود تاريخ البداية الإجباري
      if (!periodDateRange || !periodDateRange.startDate) {
        toast({
          title: "تاريخ مطلوب",
          description: "يجب تحديد تاريخ البداية لإنشاء التقرير",
          variant: "destructive",
        });
        return;
      }

      if (filteredStudents.length === 0) {
        toast({
          title: "تنبيه",
          description: "لا توجد بيانات طلاب لتصدير التقرير",
          variant: "destructive",
        });
        return;
      }

      setIsDownloading(true);

      // إظهار رسالة بداية التحميل
      toast({
        title: "بدء التحميل",
        description: "جاري إنشاء تقرير PDF...",
      });

      const result = await generateAttendanceReportPDF(
        filteredStudents,
        overallStats,
        {
          selectedGrade,
          selectedSection,
          selectedStage,
          periodDateRange,
          weeklyData,
        },
        attendanceStats
      );

      // console.log("📄 نتيجة generateAttendanceReportPDF:", result);

      if (result) {
        toast({
          title: "تم التنزيل بنجاح",
          description: "تم تنزيل تقرير الحضور والغياب بصيغة PDF",
        });
      } else {
        // console.log("❌ فشل في إنشاء PDF - النتيجة false");
        throw new Error("فشل في إنشاء ملف PDF");
      }
    } catch (error) {
      console.error("❌ خطأ في تنزيل التقرير:", error);
      console.error("❌ تفاصيل الخطأ:", error);
      const errorMessage =
        error instanceof Error ? error.message : "خطأ غير معروف";
      toast({
        title: "خطأ في التنزيل",
        description: `حدث خطأ أثناء تنزيل التقرير: ${errorMessage}`,
        variant: "destructive",
      });
    } finally {
      setIsDownloading(false);
    }
  };


  return (
    <div className="space-y-6">
      {/* Download Button */}
      <div className="flex justify-end mb-6">
        <Button
          onClick={handleDownloadPDF}
          className="bg-primary-blue hover:bg-primary-blue/90 text-white disabled:opacity-50 disabled:cursor-not-allowed"
          size="sm"
          disabled={
            filteredStudents?.length === 0 ||
            isDownloading ||
            !periodDateRange?.startDate
            //  ||
            // !selectedGrade ||
            // selectedGrade === "all" ||
            // !selectedSection ||
            // selectedSection === "all" ||
            // (hasMultipleStages && (!selectedStage || selectedStage === "all")
          // )
          }
        >
          {isDownloading ? (
            <>
              <Loader2 className="h-4 w-4 mr-2 animate-spin text-orange-600" />
              <span className="text-orange-600">جاري التحميل...</span>
            </>
          ) : (
            <>
              <FileDown className="h-4 w-4 mr-2" />
              تنزيل تقرير PDF
            </>
          )}
        </Button>
      </div>
    </div>
  );
};
